import React from "react"
import types from "prop-types"
import clsx from "clsx"
import { publicSolutionPath } from "utils/routeHelpers"
import queryParameter, { QP_CACHE_KEY } from "utils/queryParameter"

const CATEGORY_COLORS = ["bg-green", "bg-purple", "bg-orange", "bg-red"];

const getCategoryBackgroundColor = (index, categoryColor) => {
  if (categoryColor) {
    return `bg-${categoryColor}`;
  }
  return CATEGORY_COLORS[index % 4];
}

const PublicCategory = ({ categories }) => {
  const qpCacheKey = queryParameter(QP_CACHE_KEY)
  const cacheKeyQueryString = qpCacheKey ? `?${QP_CACHE_KEY}=${qpCacheKey}` : ""

  return (
    <div className="public-category-list">
      {
        categories.map((category, index) => (
          <a
            key={category.slug}
            className="public-category-list-card"
            href={`${publicSolutionPath(category.slug)}${cacheKeyQueryString}`}
          >
            <div className="public-category-list-card__body">
              <span className="public-category-list-card__name">
                {category.name}
              </span>
              <p className="public-category-list-card__description">
                {category.description}
              </p>
            </div>
            <div className={clsx("public-category-list-card__color-bar", getCategoryBackgroundColor(index, category.color))} />
          </a>
        ))
      }
    </div>
  )
}

PublicCategory.propTypes = {
  categories: types.arrayOf(types.object).isRequired,
}

export default PublicCategory
